module.exports = __webpack_public_path__ + "static/media/payments.3946f741.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/images/school_money/guide/payments.svg
// module id = 594
// module chunks = 0